import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/Landing/Header.jsx";
import Footer from "../components/Landing/footer.jsx";
import "../styles/landing-page.css";

import { useEffect } from "react";
import useRestoreScroll from "../hooks/useRestoreScroll.js";

const About = () => {
  const { t } = useTranslation();
  useRestoreScroll();
  
  // Ensure body overflow is restored when component mounts (fix for scroll issues)
  useEffect(() => {
    // Restore body overflow on mount
    document.body.style.overflow = '';
    document.body.style.overflowY = '';
    
    // Cleanup: ensure overflow is restored on unmount
    return () => {
      document.body.style.overflow = '';
      document.body.style.overflowY = '';
    };
  }, []);
  
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Header />
      <div className="about-container">
        <div className="about-header">
          <h1>{t('about.header.title')}</h1>
          <p>
            {t('about.header.subtitle')}
          </p>
        </div>
        <div className="about-cards">
          <div className="about-card vision">
            <div className="about-card-icon" style={{ color: "#7c3aed" }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="#7c3aed"
                  strokeWidth="2"
                />
                <path
                  d="M12 7a5 5 0 0 1 0 10a5 5 0 0 1 0-10z"
                  stroke="#7c3aed"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <h2>{t('about.cards.vision.title')}</h2>
            <p>
              {t('about.cards.vision.description')}
            </p>
          </div>
          <div className="about-card mission">
            <div className="about-card-icon" style={{ color: "#ff9c5a" }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="#ff9c5a"
                  strokeWidth="2"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="4"
                  stroke="#ff9c5a"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <h2>{t('about.cards.mission.title')}</h2>
            <p>
              {t('about.cards.mission.description')}
            </p>
          </div>
        </div>
        {/* Our Story Section */}
        <div className="about-story-section">
          <div className="about-story-content">
            <h2 className="about-story-title">{t('about.story.title')}</h2>
            <h3 className="about-story-subtitle">
              {t('about.story.subtitle')}
            </h3>
            <p className="about-story-desc">
              {t('about.story.paragraph1')}
            </p>
            <p className="about-story-desc">
              {t('about.story.paragraph2')}
            </p>
            <p className="about-story-desc">
              {t('about.story.paragraph3')}
            </p>
          </div>
          <div className="about-story-image">
            <img src="/images/Sulhafa-Main.png" alt="Sulhafa Turtle Mascot" />
          </div>
        </div>

        {/* The 3Cs Framework Section */}
        <div className="about-framework-section">
          <h2 className="about-framework-title">{t('about.framework.title')}</h2>
          <p className="about-framework-desc">
            {t('about.framework.description')}
          </p>
          
          <div className="about-framework-cards">
            <div className="about-framework-card curriculum">
              <div className="about-framework-icon" style={{ color: "#8548a8" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="#8548a8" strokeWidth="2"/>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="#8548a8" strokeWidth="2"/>
                  <path d="M8 7h8M8 11h8M8 15h5" stroke="#8548a8" strokeWidth="2"/>
                </svg>
              </div>
              <h3>{t('about.framework.curriculum.title')}</h3>
              <p>
                {t('about.framework.curriculum.description')}
              </p>
            </div>

            <div className="about-framework-card coaching">
              <div className="about-framework-icon" style={{ color: "#2a8ad2" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#2a8ad2" strokeWidth="2"/>
                  <circle cx="9" cy="7" r="4" stroke="#2a8ad2" strokeWidth="2"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="#2a8ad2" strokeWidth="2"/>
                </svg>
              </div>
              <h3>{t('about.framework.coaching.title')}</h3>
              <p>
                {t('about.framework.coaching.description')}
              </p>
            </div>

            <div className="about-framework-card community">
              <div className="about-framework-icon" style={{ color: "#ff9c5a" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#ff9c5a" strokeWidth="2"/>
                  <circle cx="9" cy="7" r="4" stroke="#ff9c5a" strokeWidth="2"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="#ff9c5a" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="3" stroke="#ff9c5a" strokeWidth="2"/>
                </svg>
              </div>
              <h3>{t('about.framework.community.title')}</h3>
              <p>
                {t('about.framework.community.description')}
              </p>
            </div>
          </div>
        </div>

        {/* Why We Do It Section */}
        <div className="about-purpose-section">
          <div className="about-purpose-content">
            <h2 className="about-purpose-title">{t('about.purpose.title')}</h2>
            <h3 className="about-purpose-subtitle">
              {t('about.purpose.subtitle')}
            </h3>
            <div className="about-purpose-points">
              <div className="about-purpose-point">
                <div className="about-purpose-icon" style={{ color: "#8548a8" }}>❤️</div>
                <p><strong>{t('about.purpose.points.passionate')}</strong></p>
              </div>
              <div className="about-purpose-point">
                <div className="about-purpose-icon" style={{ color: "#2a8ad2" }}>🎯</div>
                <p><strong>{t('about.purpose.points.dedicated')}</strong></p>
              </div>
              <div className="about-purpose-point">
                <div className="about-purpose-icon" style={{ color: "#ff9c5a" }}>🚀</div>
                <p><strong>{t('about.purpose.points.driven')}</strong></p>
              </div>
            </div>
            <p className="about-purpose-conclusion">
              {t('about.purpose.conclusion')}
            </p>
            <p className="about-purpose-promise">
              <strong>{t('about.purpose.promise')}</strong>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default About;
